import React from 'react'

import i18n from 'translations'

export const AreaDescriptions = [
  {
    name: i18n.t('area-descriptions:name'),
    component: React.lazy(() =>
      import('../../../modules/admin/general-parameters/areaDescriptions/AreaDescriptionsList'),
    ),
    path: '/admin/general-parameters/area-descriptions',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('area-descriptions:editingAreaDescription'),
    component: React.lazy(() =>
      import('../../../modules/admin/general-parameters/areaDescriptions/AreaDescriptionsEdit'),
    ),
    path: '/admin/general-parameters/area-descriptions/edit/:areaDescriptionId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
